import { defineComponent as _defineComponent } from 'vue'
import {
  ButtonIconContextual,
  Heading,
  ListDisplay,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { PortfolioDetailItem } from '@/modules/wealth/services/portfolio';
import { ref } from 'vue';
import { IDynamicContent } from '@/modules/common/types';
import DynamicContentModal from '@/modules/common/components/DynamicContentModal/DynamicContentModal.vue';

interface Props {
  details?: PortfolioDetailItem[];
  isLoading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TechnicalDetails',
  props: {
    details: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



const isDynamicContentModalOpen = ref(false);
const dynamicContentModal = ref({
  title: '',
  description: [] as IDynamicContent[],
  showCostsButton: false
});

const toggleDynamicModal = (row: PortfolioDetailItem) => {
  if (row) {
    dynamicContentModal.value.title = row.label;
    dynamicContentModal.value.description = row.content;
    dynamicContentModal.value.showCostsButton = !!row.action;
  }
  isDynamicContentModalOpen.value = !isDynamicContentModalOpen.value;
};

return { __sfc: true,isDynamicContentModalOpen, dynamicContentModal, toggleDynamicModal, ButtonIconContextual, Heading, ListDisplay, SkeletonLoader, DynamicContentModal }
}

})